import { Text, Container, ActionIcon, Group, rem } from "@mantine/core";
import {
  IconBrandTwitter,
  IconBrandYoutube,
  IconBrandInstagram,
  IconBrandFacebook,
} from "@tabler/icons";
import Image from "next/image";
import classes from "../styles/FooterLinks.module.css";
const data = [
  {
    title: "חברה",
    links: [
      { label: "דף הבית", link: "/" },
      { label: "אודות", link: "/about" },
      {
        label: "הורדת האפליקציה",
        link: "https://play.google.com/store/apps/details?id=com.eeefg.QuickTor&pcampaignid=web_share",
      },
      { label: "מחירון", link: "/pricing" },
      {
        label: "להרשמה",
        link: "https://app.quicktor.co.il/MainPageToConnect/CreateBusinessAccount",
      },
    ],
  },
  {
    title: "מוצר ושירותים",
    links: [
      { label: "מה זה QuickTor?", link: "/about-quicktor" },
      { label: "מרכז מידע", link: "/magazine" },
      { label: "שאלות נפוצות", link: "/faq" },
      { label: "איך לבחור מערכת לניהול תורים", link: "/choosing-appointment-system" },
      { label: "השוואת מערכות לניהול תורים", link: "/appointment-system-comparison" },
      { label: "סטטיסטיקות הברזות ומחשבון הפסד", link: "/no-show-statistics" },
      { label: "תבנית הצהרת בריאות לקוסמטיקאית", link: "/health-declaration-template" },
      { label: "ניהול תורים למספרות", link: "/managing-queues-hair-salons" },
      { label: "ניהול תורים לקוסמטיקאיות", link: "/queue-management-beauticians" },
      { label: "מערכת לניהול מכון יופי", link: "/beauty-salon-management" },
      { label: "ניהול תורים לנייליסטיות", link: "/queue-management-nail-techs" },
    ],
  },
  {
    title: "צרו קשר",
    links: [
      { label: "צור קשר", link: "/contact" },
      { label: "מייל", link: "mailto:mail@quicktor.co.il" },
      { label: "טלפון", link: "tel:0557259188" },
    ],
  },
  {
    title: "משפטי",
    links: [
      { label: "תנאי שימוש", link: "/TermsOfService" },
      { label: "מדיניות פרטיות", link: "/PrivacyPolicy" },
      { label: "הצהרת נגישות", link: "/AccessibilityStatement" },
    ],
  },
];

export function FooterLinks() {
  const groups = data.map((group) => {
    const links = group.links.map((link, index) => (
      <Text 
        key={index} 
        className={classes.link} 
        component="a" 
        href={link.link}
        target={link.external ? "_blank" : undefined}
        rel={link.external ? "noopener noreferrer" : undefined}
      >
        {link.label}
      </Text>
    ));

    return (
      <div className={classes.wrapper} key={group.title}>
        <Text className={classes.title}>{group.title}</Text>
        {links}
      </div>
    );
  });

  return (
    <footer className={classes.footer}>
      <Container className={classes.inner}>
        <div className={classes.logo}>
          {/* <MantineLogo size={30} /> */}
          <div>
            <Image
              src="/testlogo.svg"
              width={200}
              height={100}
              alt="לוגו QuickTor - המילה QuickTor בצבע כחול עם אייקון חץ מהיר, המסמל תור מהיר וזריז"
              style={{ objectFit: "contain" }}
            />
          </div>
        </div>
        <div className={classes.groups}>{groups}</div>
      </Container>
      <Container className={classes.afterFooter}>
        <Group
          gap={0}
          className={classes.social}
          justify="flex-end"
          wrap="nowrap"
        >
          {/* <ActionIcon size="lg" color="gray" variant="subtle">
            <IconBrandTwitter
              style={{ width: rem(18), height: rem(18) }}
              stroke={1.5}
            />
          </ActionIcon> */}
          <ActionIcon
            size="lg"
            color="gray"
            variant="subtle"
            component="a"
            href={"https://www.instagram.com/quick_tor"}
          >
            <IconBrandInstagram
              style={{ width: rem(18), height: rem(18) }}
              stroke={1.5}
            />
          </ActionIcon>
          <ActionIcon
            component="a"
            size="lg"
            color="gray"
            variant="subtle"
            href={"https://www.facebook.com/profile.php?id=61558413038387"}
          >
            <IconBrandFacebook
              style={{ width: rem(18), height: rem(18) }}
              stroke={1.5}
            />
          </ActionIcon>
        </Group>
        © {new Date().getFullYear()}. כל הזכויות שמורות על ידי QuickTor{" "}
      </Container>
    </footer>
  );
}
